import * as React from "react";
import { IBirthdayUser } from "../../interfaces/IBirthdayUser";
import { IAListView } from "./listView/ListView";
import { IACardView } from "./cardView/CardView";
import BirthdayService from "../../services/BirthdayService";
import "../../styles/Sharepoint_4.css";
import "../../styles/BasicIA.css";
import { LocalizationService } from "../../services/LocalizationService";
import { Helper } from "../../Helper";
import { Paging } from "../messages/paging/Paging";
import { IEnvironment } from "../../interfaces/IEnvironment";
import { IFontSlots } from "../../interfaces/IFontSlots";

export interface IBirthdayProps {
  tenant?: string;
  token?: string;
  webpartId?: string;
  environment: IEnvironment;
  title: string;
  numberResults?: number;
  display?: "ListView" | "CardView";
  topBanner?: string;
  url?: string;
  enableFilter?: boolean;
  type: string;
  filterOptions?: {};
  properties?: string[];
  users?: IBirthdayUser[];
  numDays?: number;
  years?: number[];
  emptyMessage: string;
  highlightColor: string;
  backgroundColor?: string;
  enablePaging: boolean;
  todayIcon?: string;
  isMobile?: boolean;
  showAnniversaryYear?: boolean;
  isEditMode?: boolean;
  borderRadius?: string | number;
  fontSlots?: IFontSlots;
}

export interface IBirthdayState {
  users?: IBirthdayUser[];
  isBirthday: boolean;
  pageNumber: number;
  allResults: IBirthdayUser[];
  nextId: number;
  width: number;
  isLoading: boolean;
}

export class IABirthdays extends React.Component<IBirthdayProps, IBirthdayState> {
  private componentId = "IA_birthdayWebpart_" + Helper.getRandomStringKey();

  constructor(props: IBirthdayProps) {
    super(props);
    this.state = {
      allResults: undefined,
      isBirthday: props.type === "Birthday",
      pageNumber: 1,
      nextId:
        props.numberResults && props.numberResults > 0
          ? props.numberResults
          : 2,
      width: 0,
      isLoading: false,
    };
    const localizationService = new LocalizationService();
    localizationService.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    // Resize
    window.addEventListener("resize", () => this.resize());
    this.resize();
    setTimeout(() => {
      this.resize();
    }, 0);
    try {
      var resizeObserver = new ResizeObserver(() => {
        this.resize();
      });
      resizeObserver.observe(document.getElementById(this.componentId));
    } catch {
      this.resize();
    }
  }

  public componentWillReceiveProps(props: IBirthdayProps): void {
    if (
      (props.type !== this.props.type) ||
      (props.enableFilter && props.filterOptions) ||
      (props.years !== this.props.years) || props.enablePaging !== this.props.enablePaging
    ) {
      this.setState({ allResults: undefined, isLoading: false, nextId: props.numberResults > 0 ? props.numberResults : 2, pageNumber: 1 });
    }
  }

  private resize(): void {
    let width =
      document.getElementById(`${this.componentId}`) != undefined
        ? document.getElementById(`${this.componentId}`).offsetWidth
        : 0;
    width = Math.floor(width - 3);
    this.setState({ width });
  }

  private getLastId(): number {
    return this.state.nextId * this.state.pageNumber;
  }

  private getStartId(): number {
    return this.state.nextId * (this.state.pageNumber - 1);
  }

  private hasNextPage(): boolean {
    return this.state.allResults && (this.state.allResults.length > this.getLastId());
  }

  public render(): JSX.Element {
    let panel = undefined;
    if (!this.state.allResults && !this.state.isLoading) {
      this.setState({ isLoading: true }, () => {
        BirthdayService.getBirthdays(this.props).then((birthdays) => {
          this.setState({ allResults: birthdays, isLoading: false });
        });
      }
      );
    }

    let next = [];
    let usersToShowMobile;

    const startId = this.getStartId();
    const lastId = this.getLastId();
    if (this.state.allResults) {
      next = this.state.allResults.slice(startId < 0 ? 0 : startId, lastId);
      usersToShowMobile = this.state.allResults.slice(0, lastId);
      if (usersToShowMobile.length > this.state.allResults.length) usersToShowMobile = this.state.allResults;
    } else {
      next = undefined;
    }
    let emptyMessage;
    if (!this.props.emptyMessage || this.props.emptyMessage === "") {
      emptyMessage =
        this.props.type === "Birthday"
          ? new LocalizationService().strings.Birthday_No_birthday
          : new LocalizationService().strings.Birthday_No_Anniversary;
    } else {
      emptyMessage = this.props.emptyMessage;
    }

    switch (this.props.display) {
      case "ListView":
        panel = (
          <IAListView
            properties={this.props.properties}
            users={next}
            settings={{
              isBirthday: this.props.type === "Birthday",
              message: emptyMessage,
            }}
            token={this.props.token}
            tenant={this.props.tenant}
            environment={this.props.environment}
            width={this.state.width}
            highlightColor={this.props.highlightColor}
            todayIcon={this.props.todayIcon}
            backgroundColor={this.props.backgroundColor}
            showAnniversaryYear={this.props.showAnniversaryYear}
            isEditMode={this.props.isEditMode}
            fontSlots={this.props.fontSlots}
          />
        );
        break;
      case "CardView":
        panel = (
          <IACardView
            properties={this.props.properties}
            users={this.props.isMobile ? usersToShowMobile : next}
            settings={{
              isBirthday: this.props.type === "Birthday",
              message: emptyMessage,
            }}
            token={this.props.token}
            tenant={this.props.tenant}
            environment={this.props.environment}
            width={this.state.width}
            highlightColor={this.props.highlightColor}
            todayIcon={this.props.todayIcon}
            isMobile={this.props.isMobile}
            showAnniversaryYear={this.props.showAnniversaryYear}
            isEditMode={this.props.isEditMode}
            borderRadius={this.props.borderRadius}
            fontSlots={this.props.fontSlots}
          />
        );
        break;
    }

    return (
      <div id={this.componentId}>
        <div
          className={"IA_WebpartHeader"}
          style={{
            marginBottom: "18px",
            fontFamily: this.props.fontSlots?.heading?.fontFamily
          }}
        >
          <span role="heading" aria-level={2}>
            {this.props.title}
          </span>
        </div>
        {this.props.topBanner && (
          <div />
        )}
        {panel}
        {this.props.enablePaging && this.state.allResults && this.state.allResults.length > this.props.numberResults && (
          <div
            style={{
              width: "100%",
              height: "20px",
              float: "left",
              clear: "both",
            }}
          >
            <Paging
              isLoading={this.state.isLoading}
              pageNumber={this.state.pageNumber}
              highlightColor={this.props.highlightColor}
              showPaging={this.props.enablePaging}
              isMobile={this.props.isMobile}
              hasNextPage={this.hasNextPage()}
              getNextPage={() => { this.getNextPage(); }}
              getPreviousPage={() => { this.getPreviousPage(); }}
            />
          </div>
        )}
      </div>
    );
  }

  private getNextPage(): void {
    this.setState({ pageNumber: this.state.pageNumber + 1 });
  }

  private getPreviousPage(): void {
    this.setState({ pageNumber: this.state.pageNumber - 1 });
  }

  public componentWillUnmount(): void {
    window.removeEventListener("resize", () => this.resize());
  }
}
